import { map } from "lodash";
import * as moment from "moment-timezone";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import {
  ISchedule,
  ScheduleType
} from "src/core/schedules/api/schedules.api";

export const getScheduleNaturalLanguage = (schedule: ISchedule | null, hasDetachedOrders: boolean, terminology: ITerminology) => {
  let frequencyDays = "";
  let startAndEndDates;

  const days = [
    "",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  if (schedule) {
    const weekDays =
      schedule.scheduleDays &&
      map(schedule.scheduleDays, i => {
        // @ts-ignore
        return days[ i.weekDay || i ];
      });

    // Format into list
    let formatWeekDays = weekDays ? weekDays.slice(0, -1).join(", ") + " and " + weekDays.slice(-1) : "-";

    // Unless there's just 1 day
    if (weekDays && weekDays.length === 1) {
      formatWeekDays = weekDays[ 0 ];
    }

    // const includeBankHols = schedule.bankHolidaysDelivery ? ", including bank holidays" : ".";
    const startDate = moment.utc(schedule.startDate).format("ddd DD MMM YYYY");
    const endDate = moment.utc(schedule.endDate).format("ddd DD MMM YYYY");

    frequencyDays = `${schedule.monthlyFrequency > 1 ? `every ${schedule.monthlyFrequency} weeks` : "every week"} on ${formatWeekDays}`;

    startAndEndDates = schedule.type === ScheduleType.Manual ?
      `${terminology.delivery.plural.text} will start on ${startDate} and finish on ${endDate}.` : null;
  }
  let detachedOrders;

  if (hasDetachedOrders) {
    detachedOrders = `Some orders have been manually cancelled or changed and will not be kept up to date with this ${terminology.schedule.singular.text}. These ${terminology.order.plural.text} are highlighted in <span class="highlight-warn">yellow</span> on the calendar.`;
  }

  return {
    frequencyDays,
    startAndEndDates,
    detachedOrders
  };
};
